<script setup>
import { ref, computed, onMounted } from 'vue';

const bots = [
  { name: 'Bot AI', color: '#569E5B', pct: 80 },
  { name: 'Triagem Geral', color: '#FF7937', pct: 65 },
  { name: 'IA de qualificacao', color: '#4B7D90', pct: 55 },
  { name: 'Suporte Geral', color: '#A92325', pct: 40 },
];

const mockLogs = [
  { ts: '2026-02-25 14:02:11', icon: '\uD83C\uDF99', bot: 'Bot AI', msg: 'audio token used by Bot AI on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:27', icon: '\u2699', bot: 'Bot AI', msg: 'Bot AI token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:27', icon: '\u2699', bot: 'Suporte Geral', msg: 'Suporte geral token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:30', icon: '\u2699', bot: 'IA de qualificacao', msg: 'IA de qualificacao token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:42', icon: '\u2699', bot: 'Suporte Geral', msg: 'Suporte geral token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:49', icon: '\u2699', bot: 'Suporte Geral', msg: 'Suporte geral token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:55', icon: '\u2699', bot: 'Triagem Geral', msg: 'Triagem Geral token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:59', icon: '\u2699', bot: 'Triagem Geral', msg: 'Triagem Geral token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:03:03', icon: '\uD83C\uDF99', bot: 'Bot AI', msg: 'audio token used by Bot AI on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:03:12', icon: '\uD83C\uDF99', bot: 'Bot AI', msg: 'audio token used by Bot AI on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:03:12', icon: '\uD83C\uDF99', bot: 'Bot AI', msg: 'audio token used by Bot AI on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:27', icon: '\u2699', bot: 'Bot AI', msg: 'Bot AI token used on:', conv: '#123', contact: 'Julianna_1238290' },
  { ts: '2026-02-25 14:02:27', icon: '\u2699', bot: 'Bot AI', msg: 'Bot AI token used on:', conv: '#123', contact: 'Julianna_1238290' },
];

const botColorMap = {
  'Bot AI': '#569E5B',
  'Triagem Geral': '#FF7937',
  'IA de qualificacao': '#4B7D90',
  'Suporte Geral': '#A92325',
};

function getBotColor(botName) {
  return botColorMap[botName] || '#6B7280';
}

const lastUpdated = ref(null);
onMounted(() => { lastUpdated.value = new Date(); });

const updatedText = computed(() => {
  if (!lastUpdated.value) return '';
  const diff = Math.round((Date.now() - lastUpdated.value.getTime()) / 60000);
  if (diff < 1) return 'Atualizado ha 1min';
  return 'Atualizado ha ' + diff + 'min';
});

// Radial chart: concentric rings using stroke-dasharray
const rings = computed(() => {
  const cx = 120, cy = 120;
  const radii = [100, 82, 64, 48];
  const strokeWidths = [18, 16, 14, 12];
  return bots.map((bot, i) => {
    const r = radii[i];
    const sw = strokeWidths[i];
    const circumference = 2 * Math.PI * r;
    const filled = (bot.pct / 100) * circumference;
    return { ...bot, r, sw, circumference, filled, cx, cy };
  });
});
</script>

<template>
  <div class="sz-bots-card">
    <!-- Header -->
    <div class="sz-bots-header">
      <div class="sz-bots-title-col">
        <span class="sz-bots-title">Utilizacao dos bots</span>
        <span class="sz-bots-updated">{{ updatedText }}</span>
      </div>
      <button class="sz-bots-export-btn" title="Exportar">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M3.75 12.5V15.625C3.75 15.9565 3.8817 16.2745 4.11612 16.5089C4.35054 16.7433 4.66848 16.875 5 16.875H15C15.3315 16.875 15.6495 16.7433 15.8839 16.5089C16.1183 16.2745 16.25 15.9565 16.25 15.625V12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.25 8.75L10 12.5L13.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 3.125V12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Content: Chart + Logs -->
    <div class="sz-bots-content">
      <!-- Radial Chart -->
      <div class="sz-bots-chart-area">
        <svg width="240" height="240" viewBox="0 0 240 240">
          <!-- Background rings -->
          <circle
            v-for="ring in rings"
            :key="'bg-' + ring.name"
            :cx="ring.cx" :cy="ring.cy" :r="ring.r"
            fill="none"
            :stroke="ring.color"
            stroke-opacity="0.15"
            :stroke-width="ring.sw"
          />
          <!-- Filled arcs -->
          <circle
            v-for="ring in rings"
            :key="'fg-' + ring.name"
            :cx="ring.cx" :cy="ring.cy" :r="ring.r"
            fill="none"
            :stroke="ring.color"
            :stroke-width="ring.sw"
            :stroke-dasharray="ring.filled + ' ' + (ring.circumference - ring.filled)"
            stroke-dashoffset="0"
            stroke-linecap="round"
            transform="rotate(-90 120 120)"
          />
          <!-- Center circle -->
          <circle cx="120" cy="120" r="36" :fill="bots[3].color" opacity="0.15" />
          <circle cx="120" cy="120" r="28" fill="#fff" />
        </svg>
      </div>

      <!-- Log area -->
      <div class="sz-bots-log-area">
        <div class="sz-bots-log-scroll">
          <div
            v-for="(log, i) in mockLogs"
            :key="i"
            class="sz-bot-log-line"
          >
            <span class="sz-log-ts">[{{ log.ts }}]</span>
            <span class="sz-log-icon">{{ log.icon }}</span>
            <span class="sz-log-msg" :style="{ color: getBotColor(log.bot) }">
              {{ log.msg }} <span class="sz-log-conv">{{ log.conv }}</span> {{ log.contact }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Legend -->
    <div class="sz-bots-legend">
      <div v-for="bot in bots" :key="bot.name" class="sz-bots-legend-item">
        <span class="sz-bots-legend-dot" :style="{ background: bot.color }" />
        <span class="sz-bots-legend-name">{{ bot.name }}</span>
      </div>
    </div>

    <!-- Em breve overlay -->
    <div class="sz-bots-overlay">
      <div class="sz-bots-coming-card">
        <div class="sz-coming-title">Em breve...</div>
        <div class="sz-coming-desc">Acompanhe a utilização dos seus bots</div>
        <div class="sz-coming-illustration">
          <svg width="200" height="111" viewBox="0 0 257 143" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M40.43 82.73C41.37 82.17 42.38 81.73 43.44 81.42L44.07 78.44L49.11 78.35L49.83 81.31C50.9 81.57 51.93 81.98 52.89 82.51L55.44 80.84L59.07 84.34L57.46 86.95C58.04 87.89 58.49 88.91 58.8 89.97L61.79 90.58L61.87 95.63L58.91 96.35C58.65 97.42 58.24 98.45 57.7 99.41L59.38 101.96L55.87 105.59L53.27 103.98C52.33 104.55 51.31 104.99 50.26 105.29L49.64 108.28L44.59 108.37L43.87 105.42C42.8 105.15 41.77 104.74 40.81 104.21L38.26 105.87L34.64 102.37L36.24 99.77C35.67 98.82 35.23 97.81 34.93 96.75L31.95 96.13L31.87 91.09L34.82 90.36C35.09 89.29 35.49 88.27 36.03 87.31L34.36 84.75L37.86 81.13L40.46 82.73H40.43ZM43.12 89.44C42.38 90.21 41.88 91.18 41.69 92.24C41.5 93.29 41.62 94.37 42.05 95.35C42.48 96.34 43.18 97.17 44.08 97.75C44.98 98.33 46.03 98.63 47.1 98.61C48.17 98.59 49.21 98.25 50.09 97.65C50.97 97.04 51.65 96.18 52.04 95.19C52.43 94.19 52.52 93.1 52.3 92.06C52.07 91.01 51.54 90.06 50.77 89.31C50.26 88.82 49.66 88.43 49 88.17C48.34 87.91 47.63 87.78 46.92 87.79C46.21 87.81 45.51 87.96 44.86 88.24C44.2 88.52 43.61 88.93 43.12 89.44Z" fill="#F1F1F1"/>
            <path d="M27.03 62.49C27.7 62.09 28.41 61.78 29.15 61.57L29.6 59.46L33.14 59.4L33.65 61.49C34.41 61.67 35.13 61.96 35.81 62.33L37.6 61.16L40.16 63.62L39.03 65.46C39.44 66.12 39.75 66.84 39.97 67.58L42.07 68.02L42.13 71.57L40.05 72.08C39.86 72.84 39.58 73.56 39.2 74.24L40.37 76.03L37.91 78.58L36.07 77.45C35.41 77.85 34.7 78.16 33.95 78.38L33.52 80.49L29.96 80.55L29.45 78.47C28.7 78.28 27.98 77.99 27.3 77.62L25.5 78.79L22.95 76.32L24.08 74.49C23.68 73.82 23.37 73.11 23.16 72.36L21.06 71.92L21 68.38L23.08 67.86C23.27 67.11 23.55 66.39 23.93 65.71L22.75 63.91L25.22 61.36L27.05 62.49H27.03Z" fill="#388E3C" fill-opacity="0.24"/>
            <path d="M60.73 29.86C62.75 28.64 64.92 27.69 67.19 27.05L68.51 20.69L79.3 20.5L80.86 26.86C83.14 27.4 85.34 28.24 87.4 29.37L92.85 25.79L100.62 33.29L97.24 38.91C98.45 40.93 99.39 43.09 100.04 45.36L106.4 46.69L106.59 57.49L100.23 59.05C99.68 61.34 98.81 63.54 97.66 65.6L101.24 71.05L93.74 78.83L88.26 75.43C86.24 76.65 84.07 77.6 81.8 78.24L80.48 84.6L69.69 84.78L68.13 78.42C65.85 77.85 63.65 76.99 61.59 75.84L56.07 79.48L48.31 71.98L51.69 66.46C50.48 64.43 49.54 62.26 48.9 59.99L42.54 58.67L42.31 47.81L48.66 46.26C49.21 43.97 50.07 41.76 51.2 39.7L47.66 34.24L55.15 26.48L60.73 29.86ZM66.48 44.2C64.89 45.85 63.83 47.93 63.42 50.19C63.01 52.44 63.28 54.77 64.2 56.87C65.11 58.97 66.62 60.75 68.55 61.99C70.47 63.23 72.72 63.87 75.01 63.83C77.3 63.79 79.52 63.07 81.4 61.76C83.28 60.46 84.74 58.62 85.57 56.49C86.41 54.36 86.6 52.03 86.12 49.79C85.63 47.55 84.49 45.51 82.85 43.92C81.76 42.86 80.47 42.03 79.05 41.47C77.64 40.91 76.13 40.64 74.61 40.66C73.09 40.69 71.59 41.01 70.19 41.62C68.8 42.23 67.54 43.11 66.48 44.2Z" fill="#E6E6E6"/>
            <path d="M46.92 113.7H214.04L229.71 115.31H32.46L46.92 113.7Z" fill="#616161"/>
            <path d="M52.15 109.28L109.19 108.48L141.66 40.01C142.2 38.89 143.33 38.18 144.57 38.18H231.47C233.83 38.18 235.38 40.63 234.38 42.76L200.38 114.91L50.14 114.5L52.15 109.28Z" fill="#D4D4D4"/>
            <path d="M198.36 106.07H114.82L144.22 43.64C144.75 42.51 145.88 41.79 147.13 41.79H226.75C227.93 41.79 228.71 43.03 228.2 44.1L198.36 106.07Z" fill="white"/>
            <path d="M114.01 108.48L52.15 109.28H196.77L197.57 108.48H114.01Z" fill="#8B8A8A"/>
            <path d="M119.64 114.7L200.38 114.91L234.93 41.79L199.18 112.49H122.05L119.64 109.28V112.49V114.7Z" fill="#8B8A8A"/>
            <path d="M213.64 41.79L130.48 106.07H198.37L229.31 41.79H213.64Z" fill="#F9F9F9"/>
            <path d="M155.22 87.97L148.82 89.29L154.45 90.62L154.05 91.98L146.03 90L146.44 88.58L155.61 86.61L155.22 87.97Z" fill="#388E3C"/>
            <path d="M162.85 83.94L165.36 83.95L156.44 94.21L153.93 94.21L162.85 83.94Z" fill="#388E3C"/>
            <path d="M172.93 88.62L172.51 90.04L163.37 92L163.76 90.65L170.16 89.34L164.53 88L164.92 86.65L172.93 88.62Z" fill="#388E3C"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sz-bots-card {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  padding: 16px;
  overflow: hidden;
  max-height: 336px;
}

.sz-bots-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.sz-bots-title-col {
  display: flex;
  flex-direction: column;
}

.sz-bots-title {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #000;
}

.sz-bots-updated {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #525252;
}

.sz-bots-export-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1.5px solid #D4D4D4;
  border-radius: 8px;
  background: none;
  cursor: pointer;
  color: #000;
}
.sz-bots-export-btn:hover { background: #F3F4F6; }

.sz-bots-content {
  display: flex;
  gap: 16px;
  flex: 1;
  min-height: 0;
}

.sz-bots-chart-area {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sz-bots-log-area {
  flex: 1;
  min-width: 0;
  background: #FAFAFA;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  overflow: hidden;
}

.sz-bots-log-scroll {
  max-height: 260px;
  overflow-y: auto;
  padding: 10px 12px;
}

.sz-bot-log-line {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sz-log-ts {
  color: #9CA3AF;
  margin-right: 8px;
}

.sz-log-icon {
  margin-right: 4px;
}

.sz-log-msg {
  font-weight: 500;
}

.sz-log-conv {
  font-weight: 700;
}

.sz-bots-legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #E5E7EB;
}

.sz-bots-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sz-bots-legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.sz-bots-legend-name {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #374151;
}


.sz-bots-card { position: relative; }
.sz-bots-overlay {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  background: rgba(255,255,255,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}
.sz-bots-coming-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 28px 32px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  text-align: left;
  max-width: 320px;
}
.sz-coming-title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #1C2024;
  margin-bottom: 4px;
}
.sz-coming-desc {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #60646C;
  line-height: 1.5;
  margin-bottom: 20px;
}
.sz-coming-illustration {
  display: flex;
  justify-content: center;
}
</style>

<style>
/* Dark mode */
.dark .sz-bots-card { background: #1F2125; border-color: rgba(255,255,255,0.1); }
.dark .sz-bots-title { color: #EDEEEF; }
.dark .sz-bots-updated { color: #9CA3AF; }
.dark .sz-bots-export-btn { color: #D4D4D4; border-color: #363840; }
.dark .sz-bots-export-btn:hover { background: #363840; }
.dark .sz-bots-log-area { background: #16181A; border-color: rgba(255,255,255,0.08); }
.dark .sz-log-ts { color: #6B7280; }
.dark .sz-bots-legend { border-top-color: rgba(255,255,255,0.08); }
.dark .sz-bots-legend-name { color: #D4D4D4; }
.dark .sz-bots-chart-area svg circle:last-child { fill: #1F2125; }
.dark .sz-bots-overlay { background: rgba(31,33,37,0.4); }
.dark .sz-bots-coming-card { background: rgb(20,21,23); box-shadow: 0 2px 8px rgba(0,0,0,0.3); }
.dark .sz-coming-title { color: #EDEEEF; }
.dark .sz-coming-desc { color: #B0B4BA; }
</style>
